import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { ThunkDispatch } from "redux-thunk";
import rootReducer from "./reducers";
import { configureStore } from "@reduxjs/toolkit";
import { emptySplitApi as apiSlice } from "./emptyApi";
import { rtkQueryErrorLogger } from "../middleware";
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  null,
  Action<string>
>;
export type DispatchType = ThunkDispatch<RootState, void, Action>;
const store = configureStore({
  // root reducer contains all our reducers
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware).concat(rtkQueryErrorLogger),
  
  //enable dev tools
  devTools: process.env.NODE_ENV === "development",
});
export type RootState = ReturnType<typeof store.getState>;

export default store;
